import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import DataSourceResource from '../../../DataSource.resource';
import { DataSourceRouteUtils } from '@ane/exp-data/lib/routes/DataSourceRoute.utils';
import NavigationService from '@ane/core/lib/services/NavigationService';
export const defaultReducerState = {
    items: getDefaultAsyncWrapperObj(),
};
// Action Types
const prefix = 'loadDataSourceClone';
export const cloneDataSourceConstants = {
    SetDataSourceCloneItem: `${prefix}/SetDataSourceCloneItem`,
};
const loadCloneDataSourcesArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['items'],
    loadResource: (inputPayload) => {
        return DataSourceResource.cloneDataSource({
            workspaceId: inputPayload.workspaceId,
            name: inputPayload.name,
            source: inputPayload.source,
        });
    },
    onCompleteSuccess: (resourceResult) => {
        if (!!resourceResult && !!resourceResult.Name) {
            NavigationService.navigateTo(DataSourceRouteUtils.routes.view.getURL({
                id: resourceResult === null || resourceResult === void 0 ? void 0 : resourceResult.Name,
            }));
        }
        return resourceResult;
    },
};
export const loadCloneDataSourcesEpicReducer = loadResourcesUtils(loadCloneDataSourcesArgs);
// Reducer
export const dataSourceCloneReducer = (state = defaultReducerState, action) => {
    state = loadCloneDataSourcesEpicReducer.reduxChange(state, action);
    if (action.type === cloneDataSourceConstants.SetDataSourceCloneItem) {
        return setDataSourceCloneItem(state, action);
    }
    return state;
};
export default dataSourceCloneReducer;
// Set dataSourceClone object
const setDataSourceCloneItem = (state, actionResult) => {
    return {
        ...state,
        items: actionResult.payload,
    };
};
export function SetDataSourceCloneItem(cloneDataSource) {
    return {
        type: cloneDataSourceConstants.SetDataSourceCloneItem,
        payload: cloneDataSource.items,
    };
}

//# sourceMappingURL=DataSourceClone.ducks.js.map
